/* eslint-disable
    no-restricted-globals
*/
// TODO: This file was updated by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import PropTypes from 'prop-types';
import {css, StyleSheet} from 'aphrodite';

import React from 'react';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import * as biojs from 'BioJS';
import * as CRISPRConstants from 'constants/CRISPRConstants';
import {MIT_OFF_TARGET_WEIGHTS, NUCLEASE_NAME, NUCLEASE_TYPE, PAM, URLS} from 'constants/CRISPRConstants';
import GenomeSelector from 'molbio/genome/GenomeSelector';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import {FloatingInteraction, FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import HelpButton from 'help/HelpButton';
import GenomeStore from 'stores/GenomeStore';

import getTestProps from 'test/lib/cypress/getTestProps';
import CRISPRDefaults from 'molbio/crispr/CRISPRDefaults';
import DoenchScore from './doenchScore';
import * as CRISPRUtil from './CRISPRUtil';
import PAMSelectorGroup from './PAMSelectorGroup';

const {DOENCH_GUIDE_SIZE} = DoenchScore;

const NON_BASE_EDIT_DESIGN_TYPES = [CRISPRConstants.DESIGN_TYPE.SINGLE, CRISPRConstants.DESIGN_TYPE.PAIRED];

function MaskedRegionsPopoverContent() {
  return (
    <div>
      <p>
        {'Benchling and '}
        <a href={CRISPRConstants.URLS.HSU_OFF_TARGET_PAPER} rel="noopener noreferrer" target="_blank">
          Hsu et al.
        </a>
        {' default to skipping repeats / low complexity regions when doing off-target search.'}
      </p>
      <p>Select this to include them, which may be useful e.g. for work in introns.</p>
    </div>
  );
}

function AzimuthOnTargetPopoverContent() {
  return (
    <div>
      <p>
        {'Doench, Fusi et al. have released '}
        <a href={URLS.CFD_SCORE_PAPER} rel="noopener noreferrer" target="_blank">
          a new model for on-target guide scoring.
        </a>
      </p>
      <p>Select this to use this new scoring mechanism.</p>
    </div>
  );
}

export default class SettingsForm extends React.Component {
  static propTypes = {
    allowEdits: PropTypes.bool.isRequired,
    analysis: PropTypes.object,
    initialGenome: PropTypes.object,
    setValid: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    const pam = CRISPRDefaults.get('pam');
    const state = {
      offTargetScoreType: CRISPRDefaults.get(CRISPRDefaults.KEYS.OFF_TARGET_SCORE_TYPE),
      showAdvancedSettings: false,
      showCutsOutsideRegions: CRISPRDefaults.get(CRISPRDefaults.KEYS.SHOW_CUTS_OUTSIDE_REGIONS),
      searchSoftMaskedBases: CRISPRDefaults.get(CRISPRDefaults.KEYS.SEARCH_SOFT_MASKED_BASES),
      pam,
      useAzimuthOnTargetScore: this.getUseAzimuthOnTargetScoreForPam(pam),
      mitOffTargetScoreWeights: this.getRecommendedMITScoreWeights(pam),
      ...(props.analysis != null
        ? {...props.analysis, genome: props.analysis.genome.ensemblName}
        : {
            genome: props.initialGenome
              ? props.initialGenome.ensemblName
              : CRISPRDefaults.get(CRISPRDefaults.KEYS.GENOME),
            name: 'Untitled',
            isLeftPam: Object.keys(PAM).includes(pam)
              ? CRISPRConstants.PAM_INFO_BY_PAM[pam].isLeftPam
              : CRISPRDefaults.get('isLeftPam'),
            designType: CRISPRDefaults.get('designType'),
            guideLength: CRISPRDefaults.get('guideLength'),
            pairOffsetMin: CRISPRDefaults.get('pairOffsetMin'),
            pairOffsetMax: CRISPRDefaults.get('pairOffsetMax'),
            aMin: CRISPRDefaults.get('aMin'),
            aMax: CRISPRDefaults.get('aMax'),
            tMin: CRISPRDefaults.get('tMin'),
            tMax: CRISPRDefaults.get('tMax'),
            cMin: CRISPRDefaults.get('cMin'),
            cMax: CRISPRDefaults.get('cMax'),
            gMin: CRISPRDefaults.get('gMin'),
            gMax: CRISPRDefaults.get('gMax'),
            pamSiteOnTargetMin: CRISPRDefaults.get('pamSiteOnTargetMin'),
            pamSiteOffTargetMin: CRISPRDefaults.get('pamSiteOffTargetMin'),
          }),
    };
    this.oldSettings = state;
    this.state = state;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevState, this.state)) {
      this.props.setValid(this.isValid());
    }
  }

  onPamChange = (newPam, isLeftPam) => {
    // eslint-disable-next-line benchlint/no-in-operator
    isLeftPam = newPam in PAM ? CRISPRConstants.PAM_INFO_BY_PAM[newPam].isLeftPam : isLeftPam;
    const designType = isLeftPam ? CRISPRConstants.DESIGN_TYPE.SINGLE : this.state.designType;
    this.setState({
      designType,
      pam: newPam,
      isLeftPam,
      useAzimuthOnTargetScore: this.getUseAzimuthOnTargetScoreForPam(newPam),
      mitOffTargetScoreWeights: this.getRecommendedMITScoreWeights(newPam),
    });
  };

  getRecommendedMITScoreWeights(pam) {
    if (
      // eslint-disable-next-line benchlint/no-in-operator
      pam in CRISPRConstants.PAM_INFO_BY_PAM &&
      CRISPRConstants.PAM_INFO_BY_PAM[pam].nucleaseNames.includes(NUCLEASE_NAME.SPCAS9)
    ) {
      return MIT_OFF_TARGET_WEIGHTS.SPCAS9;
    }
    return MIT_OFF_TARGET_WEIGHTS.UNWEIGHTED;
  }

  getUseAzimuthOnTargetScoreForPam = (pam) =>
    CRISPRDefaults.get(CRISPRDefaults.KEYS.USE_AZIMUTH_ON_TARGET_SCORE) &&
    pam === CRISPRConstants.AZIMUTH_SCORE_PAM;

  getAnalysisSettings = () => ({
    genome: this.state.genome,
    name: this.state.name,
    pam: this.state.pam,
    isLeftPam: this.state.isLeftPam,
    designType: this.state.designType,
    guideLength: parseInt(this.state.guideLength, 10),
    pairOffsetMin: parseInt(this.state.pairOffsetMin, 10),
    pairOffsetMax: parseInt(this.state.pairOffsetMax, 10),
    aMin: parseInt(this.state.aMin, 10),
    aMax: parseInt(this.state.aMax, 10),
    tMin: parseInt(this.state.tMin, 10),
    tMax: parseInt(this.state.tMax, 10),
    cMin: parseInt(this.state.cMin, 10),
    cMax: parseInt(this.state.cMax, 10),
    gMin: parseInt(this.state.gMin, 10),
    gMax: parseInt(this.state.gMax, 10),
    offTargetScoreType: this.state.offTargetScoreType,
    mitOffTargetScoreWeights: this.state.mitOffTargetScoreWeights,
    pamSiteOnTargetMin:
      this.state.pamSiteOnTargetMin != null ? parseInt(this.state.pamSiteOnTargetMin, 10) : null,
    pamSiteOffTargetMin:
      this.state.pamSiteOffTargetMin != null ? parseInt(this.state.pamSiteOffTargetMin, 10) : null,
    searchSoftMaskedBases: this.state.searchSoftMaskedBases,
    useAzimuthOnTargetScore: this.state.useAzimuthOnTargetScore,
  });

  getAllSettings = () =>
    // eslint-disable-next-line no-restricted-syntax
    _.extend(this.getAnalysisSettings(), {
      showCutsOutsideRegions: this.state.showCutsOutsideRegions,
    });

  getChangedAnalysisSettings = () => {
    const newSettings = this.getAnalysisSettings();
    const changedSettings = {};
    for (const [key, value] of Object.entries(newSettings)) {
      if (!isEqual(this.oldSettings[key], value)) {
        changedSettings[key] = value;
      }
    }
    return changedSettings;
  };

  getGuideLengthInputHelpText = () => {
    if (
      !isNaN(parseInt(this.state.guideLength, 10)) &&
      !(
        CRISPRConstants.MIN_GUIDE_LENGTH <= Number(this.state.guideLength) &&
        Number(this.state.guideLength) <= CRISPRConstants.MAX_GUIDE_LENGTH
      )
    ) {
      return (
        <span>
          {`Only guide lengths between ${CRISPRConstants.MIN_GUIDE_LENGTH} and ` +
            `${CRISPRConstants.MAX_GUIDE_LENGTH} are currently supported. `}
        </span>
      );
    } else if (this.state.designType === CRISPRConstants.DESIGN_TYPE.BASE_EDIT) {
      return 'Only guide lengths of 20bp are supported for base edit designs.';
    } else if (this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD) {
      return 'Only guide lengths of 20bp are supported for the CFD off-target score.';
    } else if (this.state.guideLength < DOENCH_GUIDE_SIZE) {
      return (
        'On-target scores are only defined for 20-bp or longer guides. Resulting analysis will omit ' +
        'the on-target score.'
      );
    } else {
      return null;
    }
  };

  getPAMSelectorGroupHelpText = () => {
    if (this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD) {
      return 'Only NGG PAMs can be used for the CFD off-target score.';
    } else if (!CRISPRUtil.isCas9Pam(this.state.pam)) {
      return (
        'On-target scores are only defined for Cas9 PAMs. Resulting analysis will omit the on-target ' +
        'score.'
      );
    } else if (
      CRISPRDefaults.get(CRISPRDefaults.KEYS.USE_AZIMUTH_ON_TARGET_SCORE) &&
      this.state.pam !== CRISPRConstants.AZIMUTH_SCORE_PAM
    ) {
      return (
        'Optimized on-target score can only be used with NGG PAMs. This analysis will use the 2014 ' +
        'score from Doench et. al.'
      );
    } else {
      return null;
    }
  };

  isValidPam(pam) {
    return (
      pam.length >= CRISPRConstants.MINIMUM_PAM_LENGTH &&
      pam.length <= CRISPRConstants.MAXIMUM_PAM_LENGTH &&
      biojs.util.isValidSequence(pam, biojs.util.NucleotideType.DNA)
    );
  }

  isValid = () => {
    if (
      isNaN(this.state.pairOffsetMin) ||
      Number(this.state.pairOffsetMin) !== parseInt(this.state.pairOffsetMin, 10) ||
      isNaN(this.state.pairOffsetMax) ||
      Number(this.state.pairOffsetMax) !== parseInt(this.state.pairOffsetMax, 10)
    ) {
      return false;
    }
    if (!(Number(this.state.pairOffsetMin) <= Number(this.state.pairOffsetMax))) {
      return false;
    }
    if (!this.state.pam || !this.isValidPam(this.state.pam)) {
      return false;
    }
    const percentagePairs = [
      [this.state.aMin, this.state.aMax],
      [this.state.tMin, this.state.tMax],
      [this.state.cMin, this.state.cMax],
      [this.state.gMin, this.state.gMax],
    ];
    for (const [minValue, maxValue] of Array.from(percentagePairs)) {
      for (const value of [minValue, maxValue]) {
        if (
          isNaN(value) ||
          Number(value) !== parseInt(value, 10) ||
          !(0 <= Number(value) && Number(value) <= 100)
        ) {
          return false;
        }
      }
      if (!(Number(minValue) <= Number(maxValue))) {
        return false;
      }
    }
    return true;
  };

  isGuideLengthInputDisabled = () =>
    this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD ||
    this.state.designType === CRISPRConstants.DESIGN_TYPE.BASE_EDIT;

  // The CFD score only works with 20mer guides and NGG PAM
  isPAMInputDisabled = () => this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD;

  updateDesignType = (e) => {
    const designType = e.target.value;
    if (designType === CRISPRConstants.DESIGN_TYPE.BASE_EDIT) {
      this.setState({
        designType,
        guideLength: 20,
      });
    } else {
      this.setState({
        designType,
      });
    }
  };

  toggleMITOffTargetScoreWeights = (useSpCas9Weights) => {
    if (useSpCas9Weights) {
      this.setState({mitOffTargetScoreWeights: MIT_OFF_TARGET_WEIGHTS.SPCAS9});
    } else {
      this.setState({mitOffTargetScoreWeights: MIT_OFF_TARGET_WEIGHTS.UNWEIGHTED});
    }
  };

  updateShowCutsOutsideRegions = (showCutsOutsideRegions) => {
    this.setState({showCutsOutsideRegions});
  };

  updateOffTargetScoreType = (offTargetScoreType) => {
    // CFD can only be used with 20mer guides and NGG PAM
    if (offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD) {
      this.setState({
        guideLength: CRISPRConstants.CFD_SCORE_GUIDE_LENGTH,
        offTargetScoreType,
        pam: CRISPRConstants.CFD_SCORE_PAM,
      });
    } else {
      this.setState({offTargetScoreType});
    }
  };

  showOnTarget = () => this.state.pamSiteOnTargetMin != null;

  showOffTarget = () => this.state.pamSiteOffTargetMin != null;

  updateShowOnTarget = (e) => {
    this.setState({
      pamSiteOnTargetMin: e.target.checked ? CRISPRConstants.DEFAULTS.PAM_SITE_ON_TARGET_MIN : null,
    });
  };

  updateShowOffTarget = (e) => {
    this.setState({
      pamSiteOffTargetMin: e.target.checked ? CRISPRConstants.DEFAULTS.PAM_SITE_OFF_TARGET_MIN : null,
    });
  };

  toggleAdvancedSettings = (e) => {
    this.setState({showAdvancedSettings: !this.state.showAdvancedSettings});
  };

  getSingleGuideSubtitle = () => {
    const nucleaseType = CRISPRUtil.getNucleaseType(this.state.pam, this.state.isLeftPam);
    return `Wild-type ${nucleaseType}, single gRNA ${
      nucleaseType === NUCLEASE_TYPE.CAS9 ? '(higher efficiency)' : ''
    }`;
  };

  getPairedGuideSubtitle = () => {
    if (CRISPRUtil.getNucleaseType(this.state.pam, this.state.isLeftPam) === NUCLEASE_TYPE.CAS9) {
      return 'Double Cas9 nickase, two gRNAs (lower off-target effects)';
    }
    return 'Cpf1 nickase is not available';
  };

  render() {
    return (
      <div>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Design type</Label>
            </Col>
            <Col sm={8}>
              <div className="radio">
                <label>
                  <input
                    type="radio"
                    name="design-type"
                    value={CRISPRConstants.DESIGN_TYPE.SINGLE}
                    checked={this.state.designType === CRISPRConstants.DESIGN_TYPE.SINGLE}
                    onChange={this.updateDesignType}
                    disabled={!this.props.allowEdits}
                    {...getTestProps({component: 'SettingsForm', element: 'radioInput', key: 'singleGuide'})}
                  />
                  Single guide
                  <div className="faded">{this.getSingleGuideSubtitle()}</div>
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    type="radio"
                    name="design-type"
                    value={CRISPRConstants.DESIGN_TYPE.PAIRED}
                    checked={this.state.designType === CRISPRConstants.DESIGN_TYPE.PAIRED}
                    onChange={this.updateDesignType}
                    disabled={!this.props.allowEdits || this.state.isLeftPam}
                    {...getTestProps({component: 'SettingsForm', element: 'radioInput', key: 'pairedGuide'})}
                  />
                  Paired guides
                  <div className="faded">{this.getPairedGuideSubtitle()}</div>
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    type="radio"
                    name="design-type"
                    value={CRISPRConstants.DESIGN_TYPE.BASE_EDIT}
                    checked={this.state.designType === CRISPRConstants.DESIGN_TYPE.BASE_EDIT}
                    onChange={this.updateDesignType}
                    disabled={false}
                    {...getTestProps({component: 'SettingsForm', element: 'radioInput', key: 'baseEditing'})}
                  />
                  Guides for "base editing" (Komor et al., 2016)
                  <div className="faded">C -&gt; T (or G -&gt; A) substitution, no dsDNA breaks</div>
                </label>
              </div>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Guide length</Label>
            </Col>
            <Col sm={8}>
              <input
                type="number"
                required={true}
                min={CRISPRConstants.MIN_GUIDE_LENGTH}
                max={CRISPRConstants.MAX_GUIDE_LENGTH}
                name="guide-length"
                placeholder="Guide length (bp)"
                value={this.state.guideLength}
                onChange={(e) => this.setState({guideLength: e.target.value})}
                disabled={this.isGuideLengthInputDisabled() || !this.props.allowEdits}
                {...getTestProps({component: 'SettingsForm', element: 'numberInput', key: 'guideLength'})}
              />
              <p className="help-block">{this.getGuideLengthInputHelpText()}</p>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col className="text-right" sm={3}>
              <Label className="u-input-line-height">Genome</Label>
            </Col>
            <Col sm={8}>
              <GenomeSelector
                genomes={GenomeStore.getGenomes()}
                genomeLink={{
                  value: this.state.genome,
                  requestChange: (genome) => this.setState({genome}),
                }}
                disabled={!this.props.allowEdits}
              />
            </Col>
          </Row>
        </FormGroup>
        <PAMSelectorGroup
          pamLink={{
            value: this.state.pam,
            isLeftPam: this.state.isLeftPam,
            requestChange: this.onPamChange,
          }}
          disabled={this.isPAMInputDisabled() || !this.props.allowEdits}
          helpText={this.getPAMSelectorGroupHelpText()}
          designType={this.state.designType}
        />
        {this.state.designType === CRISPRConstants.DESIGN_TYPE.PAIRED ? (
          <FormGroup>
            <Row>
              <Col className="text-right" sm={3}>
                <Label className="u-input-line-height">Pair offset</Label>
              </Col>
              <Col sm={2}>
                <input
                  type="number"
                  name="pair-offset-min"
                  placeholder="Min (bp)"
                  value={this.state.pairOffsetMin}
                  onChange={(e) => this.setState({pairOffsetMin: e.target.value})}
                  disabled={!this.props.allowEdits}
                />
              </Col>
              <Col sm={2}>
                <input
                  type="number"
                  name="pair-offset-max"
                  placeholder="Max (bp)"
                  value={this.state.pairOffsetMax}
                  onChange={(e) => this.setState({pairOffsetMax: e.target.value})}
                  disabled={!this.props.allowEdits}
                />
              </Col>
            </Row>
          </FormGroup>
        ) : undefined}
        <FormGroup className="text-right">
          <a onClick={this.toggleAdvancedSettings}>
            {this.state.showAdvancedSettings ? 'Hide advanced settings' : 'Show advanced settings'}
          </a>
        </FormGroup>
        {this.state.showAdvancedSettings
          ? [
              <hr key="hr" />,
              <FormGroup key="masked-off-target">
                <Row>
                  <Col className="text-right" sm={3}>
                    <Label className="u-input-line-height">Masked regions</Label>
                  </Col>
                  <Col sm={8}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.searchSoftMaskedBases}
                          onChange={(e) => this.setState({searchSoftMaskedBases: e.target.checked})}
                          disabled={!this.props.allowEdits}
                        />
                        {'Include masked regions in off-target search '}
                      </label>
                      <HelpButton
                        title="Include masked regions"
                        renderContent={() => <MaskedRegionsPopoverContent />}
                        interaction={FloatingInteraction.HOVER}
                        placement={FloatingPlacement.TOP}
                      />
                    </div>
                  </Col>
                </Row>
              </FormGroup>,
              NON_BASE_EDIT_DESIGN_TYPES.includes(this.state.designType) ? (
                <FormGroup key="off-target-score-type">
                  <Row>
                    <Col className="text-right" sm={3}>
                      <Label className="u-input-line-height">Off-target score</Label>
                      <div className={css(styles.offTargetScoreHelpButton)}>
                        <HelpButton
                          title="Off-target score"
                          renderContent={() =>
                            'The aggregate off-target score is computed by the formula 100/(100+∑(scores)). You can choose the scoring formula for the individual guide scores.'
                          }
                          interaction={FloatingInteraction.HOVER}
                          placement={FloatingPlacement.TOP}
                        />
                      </div>
                    </Col>
                    <Col sm={8}>
                      <div className="radio">
                        <label>
                          <input
                            type="radio"
                            value="hide"
                            checked={
                              this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.MIT
                            }
                            onChange={() =>
                              this.updateOffTargetScoreType(CRISPRConstants.OFF_TARGET_SCORE_TYPE.MIT)
                            }
                            disabled={!this.props.allowEdits}
                          />
                          {'Use the scoring method from '}
                          <a
                            href={CRISPRConstants.URLS.HSU_OFF_TARGET_PAPER}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            Hsu et al., 2013
                          </a>
                        </label>
                      </div>
                      <div className="radio">
                        <label>
                          <input
                            type="radio"
                            value="hide"
                            checked={
                              this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD
                            }
                            onChange={() =>
                              this.updateOffTargetScoreType(CRISPRConstants.OFF_TARGET_SCORE_TYPE.CFD)
                            }
                          />
                          {'Use the Cutting Frequency Determination (CFD) score from '}
                          <a
                            href={CRISPRConstants.URLS.CFD_SCORE_PAPER}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            Doench, Fusi et al. (2016).
                          </a>
                          {' Only available for NGG PAM sites and 20mer guides.'}
                        </label>
                      </div>
                    </Col>
                  </Row>
                </FormGroup>
              ) : undefined,
              NON_BASE_EDIT_DESIGN_TYPES.includes(this.state.designType) &&
              this.state.offTargetScoreType === CRISPRConstants.OFF_TARGET_SCORE_TYPE.MIT ? (
                <FormGroup key="off-target-score-weights">
                  <Row>
                    <Col className="text-right" sm={3}>
                      <Label className="u-input-line-height">Off-target weights</Label>
                    </Col>
                    <Col sm={8}>
                      <div className="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            checked={this.state.mitOffTargetScoreWeights === MIT_OFF_TARGET_WEIGHTS.SPCAS9}
                            onChange={(e) => this.toggleMITOffTargetScoreWeights(e.target.checked)}
                            disabled={!this.props.allowEdits}
                          />
                          {'When calculating MIT off-target scores, use weights designed for ' +
                            'SpCas9 nucleases (from Hsu et al., 2013). '}
                        </label>
                        <HelpButton
                          title="Off-target weights"
                          renderContent={() =>
                            'When this option is checked, off-target scores will be calculated using the weights described for SpCas9 in Hsu et al., 2013. When not checked, all base mismatch positions will be given equal weight regardless of how far they are from the cut site.'
                          }
                          interaction={FloatingInteraction.HOVER}
                          placement={FloatingPlacement.TOP}
                        />
                      </div>
                    </Col>
                  </Row>
                </FormGroup>
              ) : undefined,
              NON_BASE_EDIT_DESIGN_TYPES.includes(this.state.designType) ? (
                <FormGroup key="azimuth-on-target">
                  <Row>
                    <Col className="text-right" sm={3}>
                      <Label className="u-input-line-height">On-target score</Label>
                    </Col>
                    <Col sm={8}>
                      <div className="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            checked={this.state.useAzimuthOnTargetScore}
                            onChange={(e) => this.setState({useAzimuthOnTargetScore: e.target.checked})}
                            disabled={
                              !this.props.allowEdits || this.state.pam !== CRISPRConstants.AZIMUTH_SCORE_PAM
                            }
                          />
                          {'Use optimized score from Doench, Fusi et al., 2016. Only available for SpCas9. '}
                        </label>
                        <HelpButton
                          title="On-target score"
                          renderContent={() => <AzimuthOnTargetPopoverContent />}
                          interaction={FloatingInteraction.HOVER}
                          placement={FloatingPlacement.TOP}
                        />
                      </div>
                    </Col>
                  </Row>
                </FormGroup>
              ) : undefined,
              NON_BASE_EDIT_DESIGN_TYPES.includes(this.state.designType) ? (
                <FormGroup key="sequence-display">
                  <Row>
                    <Col className="text-right" sm={3}>
                      <Label className="u-input-line-height">Sequence display</Label>
                    </Col>
                    <Col sm={8}>
                      <div className="radio">
                        <label>
                          <input
                            type="radio"
                            value="hide"
                            checked={!this.state.showCutsOutsideRegions}
                            onChange={() => this.updateShowCutsOutsideRegions(false)}
                            disabled={!this.props.allowEdits}
                          />
                          Show only cuts in the target region(s)
                        </label>
                      </div>
                      <div className="radio">
                        <label>
                          <input
                            type="radio"
                            value="show"
                            checked={this.state.showCutsOutsideRegions}
                            onChange={() => this.updateShowCutsOutsideRegions(true)}
                            disabled={!this.props.allowEdits}
                          />
                          Show all potential cuts on the sequence
                        </label>
                      </div>
                      <div className="checkbox">
                        <label className="u-input-line-height">
                          <input
                            type="checkbox"
                            name="show-on-target"
                            checked={this.showOnTarget()}
                            onChange={this.updateShowOnTarget}
                            disabled={!this.props.allowEdits}
                          />
                          {'Show cut if on-target score is over '}
                          <input
                            className="u-inline-form-input-sm"
                            type="number"
                            min={0}
                            max={100}
                            name="pam-site-on-target-min"
                            value={this.state.pamSiteOnTargetMin}
                            onChange={(e) => this.setState({pamSiteOnTargetMin: e.target.value})}
                            disabled={!this.showOnTarget() || !this.props.allowEdits}
                          />
                        </label>
                      </div>
                      <div className="checkbox">
                        <label className="u-input-line-height">
                          <input
                            type="checkbox"
                            name="show-off-target"
                            checked={this.showOffTarget()}
                            onChange={this.updateShowOffTarget}
                            disabled={!this.props.allowEdits}
                          />
                          {'Show cut if off-target score is over '}
                          <input
                            className="u-inline-form-input-sm"
                            type="number"
                            min={0}
                            max={100}
                            name="pam-site-off-target-min"
                            value={this.state.pamSiteOffTargetMin}
                            onChange={(e) => this.setState({pamSiteOffTargetMin: e.target.value})}
                            disabled={!this.showOffTarget() || !this.props.allowEdits}
                          />
                        </label>
                      </div>
                    </Col>
                  </Row>
                </FormGroup>
              ) : undefined,
              <Row key="guide-composition">
                <Col className="text-right" sm={3}>
                  <Label>Guide composition settings</Label>
                </Col>
                <Col sm={8}>
                  <FormGroup key="min">
                    <Row>
                      <Col className="text-center col-sm-offset-3" sm={3}>
                        <Label>Min</Label>
                      </Col>
                      <Col className="text-center" sm={3}>
                        <Label>Max</Label>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup key="col-A">
                    <Row>
                      <Col className="text-right" sm={3}>
                        <Label className="u-input-line-height">% A</Label>
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="a-min"
                          value={this.state.aMin}
                          onChange={(e) => this.setState({aMin: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="a-max"
                          value={this.state.aMax}
                          onChange={(e) => this.setState({aMax: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup key="col-T">
                    <Row>
                      <Col className="text-right" sm={3}>
                        <Label className="u-input-line-height">% T</Label>
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="t-min"
                          value={this.state.tMin}
                          onChange={(e) => this.setState({tMin: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="t-max"
                          value={this.state.tMax}
                          onChange={(e) => this.setState({tMax: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup key="col-C">
                    <Row>
                      <Col className="text-right" sm={3}>
                        <Label className="u-input-line-height">% C</Label>
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="c-min"
                          value={this.state.cMin}
                          onChange={(e) => this.setState({cMin: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="c-max"
                          value={this.state.cMax}
                          onChange={(e) => this.setState({cMax: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup key="col-G">
                    <Row>
                      <Col className="text-right" sm={3}>
                        <Label className="u-input-line-height">% G</Label>
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="g-min"
                          value={this.state.gMin}
                          onChange={(e) => this.setState({gMin: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                      <Col sm={3}>
                        <input
                          type="number"
                          min={0}
                          max={100}
                          name="g-max"
                          value={this.state.gMax}
                          onChange={(e) => this.setState({gMax: e.target.value})}
                          disabled={!this.props.allowEdits}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>,
            ]
          : undefined}
      </div>
    );
  }
}

const styles = StyleSheet.create({
  offTargetScoreHelpButton: {paddingLeft: '4px', display: 'inline-block'},
});
